import { Link } from 'react-router-dom';
import './TermsOfService.scss';
import { ROUTES } from '../../constants/routes';
import { scrollTop } from '../../helpers/scrollTop';
import { useEffect } from 'react';

export const TermsOfServiceRS = () => {
  useEffect(() => {
    scrollTop();
  });
  return (
    <section className="terms">
      <div className="_container terms__container">
        <h1 className="terms__title title">SIXTIX Uslovi korišćenja</h1>
        <div>
          <p>
            <strong>Ažurirano: 14.02.2025 godine</strong>
          </p>
          <p>
            (prodaja ulaznica preko distributerske mreže SIXTIX d.o.o. Beograd)
          </p>
          <p>
            <strong>VAŽNA INFORMACIJA</strong>
          </p>
          <p>
            SIXTIX d.o.o. Beograd (u daljem tekstu: &quot;SIXTIX&quot;) nije
            organizator ponuđenih događaja.
          </p>
          <p>
            Događaj organizuje organizator događaja, koji takođe izdaje ulaznice
            (u daljem tekstu: &quot;Organizator&quot;).
          </p>
          <p>
            SIXTIX deluje isključivo kao distributer za prodaju ulaznica u ime
            organizatora, zbog čega ne snosi nikakvu odgovornost u vezi sa
            organizacijom i/ili održavanjem događaja, te nije odgovoran za
            povraćaj novca.
          </p>

          <br />

          <p className="terms__subtitle">
            <strong>1. Uvod</strong>
          </p>
          <p>
            Dobrodošli na SIXTIX (dalje u tekstu{' '}
            <strong>Kompanija, SIXTIX</strong>; zvanično ime: SIXTIX D.O.O.
            BEOGRAD; adresa: Humska 1, Beograd (Savski venac), matični broj:
            21940291, PIB: 11388625, šifra delatnosti i delatnost: 7990 – ostale
            usluge rezervacije i delatnosti povezane sa njima; mail adresa:{' '}
            <a className="terms__link-rs" href="mailto:info@sixtix.com">
              info@sixtix.com
            </a>
            , kontakt telefon: +381 69 8017686, web adresa{' '}
            <a className="terms__link-rs" href="https://www.sixtix.com">
              https://www.sixtix.com
            </a>
            ).
          </p>
          <p>
            Molimo vas da pažljivo pročitate Uslove korišćenja pre nego što
            koristite ovaj veb-sajt. Posetom i korišćenjem ovog veb-sajta na
            bilo koji način sklapate pravni ugovor sa SIXTIX d.o.o. i
            obavezujete se da ćete u potpunosti poštovati ove Uslove.
          </p>
          <p>
            Ovi uslovi korišćenja sačinjeni su u skladu sa regulativom Republike
            Srbije koja uređuje ovu oblast i to u skladu sa: Zakonom o zaštiti
            potrošača, Zakonom o elektronskoj trgovini, Zakonom o trgovini,
            Zakonom o oglašavanju, Zakonom o platnim uslugama i Zakonom o
            zaštiti korisnika finansijskih usluga kod ugovaranja na daljinu.
          </p>
          <p>
            Molimo da se, pre kupovine usluge putem ove internet stranice,
            detaljno upoznate sa Uslovima korišćenja iste, kako biste imali na
            raspolaganju sve neohodne informacije u cilju donošenja odluke.
            Kupovinom usluge putem ove internet stranice, saglašavate se sa svim
            uslovima i informacijama koje su Vam prezentovane, te potvrđujete da
            ste ove Uslove korišćenja pročitali, razumeli i prihvatili u
            celosti. Uslovima korišćenja regulisani su uslovi kupovine usluge,
            prava i obaveze potrošača i ostala pitanja od značaja za
            funkcionisanje i obavljanja kupovine putem internet stranice.
          </p>
          <p>
            Naša Politika privatnosti dopunjuje ove Uslove korišćenja.
            Preporučujemo da pažljivo pročitate ove informacije i povremeno
            proveravate ažuriranja.
          </p>
          <p>
            SIXTIX pruža platformu organizatorima događaja za prodaju karata
            putem interneta, a kupcima (&quot;vama&quot;) omogućava kupovinu tih
            karata. Mi delujemo kao posrednici i nismo organizatori događaja.
            Odgovornost za sadržaj događaja, dostupnost karata i otkazivanja
            leži isključivo na organizatorima događaja.
          </p>

          <br />

          <p className="terms__subtitle">
            <strong>2. Način kupovine</strong>
          </p>
          <p>
            Ako kupite karte od prodavca preko Servisa, karta će vam biti
            poslata putem e-pošte nakon što je proces kupovine karte završen.
            Nećete dobiti papirnu kopiju karte od SIXTIX, već samo elektronsku
            kopiju kupljene karte.
          </p>
          <p>
            Kupovina ulaznica na Internet prodavnici je obavezujuća i kupac ne
            može odustati od izvršene kupovine u smislu člana 36. stav 1 tačke
            12 i 13 Zakona o zaštiti potrošača, s obzirom na to da SIXTIX
            prodajom ulaznica pruža usluge povezane sa slobodnim aktivnostima
            koje se odvijaju u tačno određeno vreme odnosno u određenom periodu
            (odnosno za koje postoji konkretni rok ili period izvršenja), kao i
            da je reč o isporuci digitalnog sadržaja u vidu PDF ulaznica ili u
            vidu elektronske ulaznice sa QR kodom u digitalnom walletu
            (novčaniku). U skladu sa članom 36 stav 1 tačka 13 i članom 26. stav
            1. tačka 6 Zakona o zaštiti potrošača, kupac prihvatanjem ovih
            Uslova korišćenja izričito izjavljuje da je obavešten od strane
            SIXTIX-a da ne može koristiti pravo na odustanak od ugovora, na šta
            kupac pristaje.
          </p>
          <p>Zaštita podataka o finansijskoj transakciji</p>
          <p>
            Prilikom unošenja podataka o platnoj kartici, poverljive informacija
            se prenose putem javne mreže u zaštićenoj (kriptovanoj) formi
            upotrebom SSL protokola i PKI sistema, kao trenutno najsavremenije
            kriptografske tehnologije. Sigurnost podataka prilikom kupovine,
            garantuje procesor platnih kartica, Banka prihvatilac, pa se tako
            kompletni proces naplate obavlja na bezbednoj stranici, čiji je
            procesor Banka. Niti jednog trenutka podaci o platnoj kartici nisu
            dostupni našem sistemu.
          </p>
          <p>Izjava o konverziji</p>
          <p>
            Sva plaćanja biće izvršena u lokalnoj valuti Republike Srbije –
            dinar (RSD). Za informativni prikaz cena u drugim valutama koristi
            se kurs Narodne Banke Srbije. Iznos za koji će biti zadužena Vaša
            platna kartica biće izražen u Vašoj lokalnoj valuti kroz konverziju
            u istu po kursu koji koriste kartičarske organizacije/Vaša banka
            izdavalac, a koji nama u trenutku transakcije ne može biti poznat.
            Kao rezultat ove konverzije postoji mogućnost neznatne razlike od
            originalne cene navedene na našem sajtu i one koju možete videti na
            vašem bankovnom izvodu. Hvala Vam na razumevanju.
          </p>

          <br />

          <p className="terms__subtitle">
            <strong>3. Opis usluge i cena</strong>
          </p>
          <p>
            Veb sajt sixtix.com i SixTix servis namenjeni su organizacijama koje
            žele da prodaju karate onlajn direktno posetiocima ili potencijalnim
            kupcima karata. Sajt sixtix.com kao domen direktno, nisu povezani ni
            sa jednom od organizacija koje prodaju karte preko Servisa.
          </p>
          <p>
            Dostupnost i cene karata. O dostupnosti broju ulaznica za događaje
            ili nastupe, odlučuje isključivo organizacija. Cene ulaznica
            određuje organizacija koja prodaje karte. Povrh cene karte (bilo
            kojih troškove usluge), SixTix obračunava naknadu za obradu uplata
            koju zadržava SixTix.
          </p>
          <p>Izjava o PDV-u</p>
          <p>PDV uračunat u cenu i nema skrivenih troškova</p>

          <br />

          <p className="terms__subtitle">
            <strong>4. Obaveze korisnika</strong>
          </p>
          <p>
            Korišćenjem ove internet stranice garantujete da imate najmanje 18
            godina starosti i da su lični podaci koje pružate tačni i potpunu.
            Slažete se da će te koristiti stranicu samo u zakonite svrhe i na
            način koji ne narušava prava drugih, niti ograničava i sprečava
            korišćenje stranice od strane bilo koga drugog.
          </p>
          <p>
            <strong>4.1. ZABRANA ZLOUPOTREBE</strong>
          </p>
          <p>
            Korisnik koji pristupa internet stranici je dužan da se uzdržava od
            svakog ponašanja koje može predstavljati zloupotrebu. Postupak
            korisnika smatraće se zloupotrebom ili nedozvoljenom radnjom ako je
            u suprotnosti sa pozitivnim propisima, savešću i dobrim poslovnim
            običajima. Korisnicima internet stranice nije dozvoljeno da:
          </p>
          <ul>
            <li>
              ometaju i/ili onemogućavaju bilo koje funkcije povezane sa
              sigurnošću na internet stranici ili funkcije koje sprečavaju ili
              ograničavaju upotrebu ili kopiranje dostupnog sadržaja;
            </li>
            <li>
              objavljuju i/ili prenose svaki materijal koji je preteći,
              klevetnički, nepristojan, uvredljiv, pornografski ili
              zlostavljački.
            </li>
            <li>daju netačne informacije koje se tiču podataka o ličnosti;</li>
            <li>
              koriste tuđe lične podatke bez saglasnosti tog lica ili lažno
              predstavljaju da istupaju u ime bilo kog trećeg lica,
            </li>
            <li>
              se bave bilo kojim nezakonitim ili protivpravnim ponašanjem preko
              internet stranice;
            </li>
            <li>
              preduzimaju protivpravne radnje (hakerski upadi i sl.) na internet
              stranici i uvezi sa istom;
            </li>
            <li>koriste specijalizovane programe radi preuzimanja sadržaja.</li>
            <li>
              zloupotrebljavaju pravila i uslove kupovine u bilo koje druge
              svrhe osim u svrhe kupovine usluge.
            </li>
          </ul>
          <p>
            U situacijama u kojima se utvrdi da je porudžbina kreirana sa ciljem
            zloupotrebe, trgovac zadržava pravo da takvu porudžbinu otkaže. U
            slučaju kršenja uslova korišćenja, odnosno svakog protivpravnog ili
            malicioznog ponašanja na internet stranici i u vezi sa istom,
            trgovac ima pravo da preduzme sva pravno dozvoljena sredstva u cilju
            zaštite svojih prava i interesa. Ukoliko na internet stranici
            korisnik ostavi svoj komentar, recenziju, ocenu usluge, fotografiju
            itd, prihvatanjem ovih Uslova korišćenja, korisnik se saglašava sa
            korišćenjem takvog komentara, recenzije, ocene ili fotografije u
            marketinške svrhe.
          </p>
          <p>
            <strong>4.2. NEDOZVOLJENE TRANSAKCIJE</strong>
          </p>
          <p>
            Trgovac se obavezuje da će vršiti prodaju robe i/ili usluga u skladu
            sa zakonom i propisima Republike Srbije. Na internet prodajnom mestu
            izričito je zabranjeno nuditi robu/usluge iz sledećih kategorija:
          </p>
          <ul>
            <li>radioaktivne, otrovne i eksplozivne materije</li>
            <li>hemijske proizvode štetne za okolinu</li>
            <li>zaštićene životinjske i biljne vrste</li>
            <li>ljudske ili životinjske organe</li>
            <li>opojne droge</li>
            <li>pornografski materijal</li>
            <li>
              lekovi kao i drugih kategorija propisanih zakonskom ili
              regulativom kartičarskih organizacija.
            </li>
          </ul>
          <p>
            Na internet stranici je moguće obaviti kupovinu u svojstvu fizičkog
            lica, preduzetnika i pravnog lica. Ukoliko se za kupovinu izvrši
            plaćanje platnom karticom privrednog društva/preduzetnika, u tom
            slučaju trgovac ni banka ne odgovaraju za poreske kao i druge
            zakonske obaveze koje prate platnu transakciju i osnovni pravni
            posao na osnovu kojeg je transakcija izvršena, niti bilo koje druge
            poreze koji mogu nastati prilikom kupovine usluge. U procesu
            obavljanja kupovine, potrošač izjavljuje da je upoznat i saglasan sa
            Uslovima korišćenja i Politikom privatnosti. Informacije objavljene
            na internet stranici u vezi sa uslugama koje se nude na prodaju ne
            predstavljaju ponudu za zaključenje ugovora, nego poziv da se od
            strane potrošača učini ponuda. Ugovor o kupovini usluge se smatra
            zaključenim onog momenta kada potrošaču putem e-mail-a bude
            dostavljena potvrda porudžbine i račun trgovca.
          </p>
          <p>
            <strong>4.3. ZAŠTITA PODATAKA O LIČNOSTI</strong>
          </p>
          <p>
            Podatak o ličnosti u smislu Zakona o zaštiti podataka o ličnosti je
            svaki podatak koji se odnosi na fizičko lice čiji je identitet
            određen ili odrediv, neposredno ili posredno, posebno na osnovu
            oznake identiteta, kao što je ime i identifikacioni broj, podatak o
            lokaciji, identifikator u elektronskim komunikacionim mrežama ili
            jednog, odnosno više obeležja njegovog fizičkog, fiziološkog,
            genetskog, mentalnog, ekonomskog, kulturnog i društvenog identiteta.
            Obrada podataka o ličnosti je svaka radnja ili skup radnji koje se
            vrše automatizovano ili neautomatizovano sa podacima o ličnosti ili
            njihovim skupovima, kao što su prikupljanje, beleženje,
            razvrstavanje, grupisanje, odnosno strukturisanje, pohranjivanje,
            upodobljavanje ili menjanje, otkrivanje Sva pitanja od značaja za
            zaštitu podataka o ličnosti, obradu istih i Vaša prava po tom osnovu
            molimo da posetite Politiku privatnosti. Poverljivost podataka
            Trgovcu je zabranjeno prodavanje, naručivanje, obezbeđivanje illi
            razmena podataka potrošača ili informacija o platnoj kartici u bilo
            kojoj formi trećoj strani, sem ako to nije Banka ili nadležni
            državni organi. Lični i adresni podaci potrošača koji se predočavaju
            Trgovcu prilikom procesa kupovine smatraju se poslovnom tajnom. Ovi
            podaci takođe su regulisani Zakonom o zaštiti podataka o ličnosti.
            Trgovac se obavezuje da od potrošača neće zahtevati i arhivirati u
            bilo kojoj elektronskoj formi, podatke vezane za platnu karticu
            kojom se transakcija realizuje a posebno broj kartice, datum
            isticanja, CVC2 ili CVV broj, itd.
          </p>
          <p>
            Klikom na sledeći link možete videti našu{' '}
            <Link to={ROUTES.POLICY} className="terms__link-rs">
              Politiku privatnosti
            </Link>
            .
          </p>

          <br />

          <p className="terms__subtitle">
            <strong>5.⁠ ⁠Plaćanja na SIXTIX</strong>
          </p>
          <p>
            Sva plaćanja se obrađuju putem pouzdanih spoljnih sistema plaćanja.
            Plaćanje putem prihvatanja platnih kartica (Visa, Master, Maestro,
            Dina) obavlja se preko sledećih pružaoca usluga: Institucije
            elektronskog novca PaySpot doo Novi Sad, sa sedištem u Novom Sadu,
            ul. Branimira Ćosića 2/II/201B, MB: 21157074, PIB: 109296534, u
            daljem tekstu: Institucija i Raiffeisen Bank AD, sa registrovanim
            sedištem u Beogradu, ul. Đorđa Stanojevića 16, MB: 17335600, PIB:
            100000299 u daljem tekstu: Banka.
          </p>
          <p>
            Potrošač je, kako bi realizovao kupovinu usluge, dužan da na
            označenoj sigurnoj formi stranice unese podatke svoje platne
            kartice. Ukoliko je transakcija izvršena, potrošač će biti obavešten
            da je rezervacija sredstava u iznosu kreirane porudžbine uspešno
            obavljena. Prihvatanjem ovih Uslova korišćenja potrošač je saglasan
            da mu se u momentu inicijalnog poručivanja rezervišu sredstva u
            iznosu kreirane porudžbine, kao i da se njegova platna kartica
            zaduži za iznos sa računa za realizovanu kupovinu usluge. Podaci o
            platnoj kartici čuvaju se na sigurnoj zaštićenoj stranici Banke u
            kriptovanoj formi i nisu dostupni drugim stranama u procesu
            plaćanja. Podaci o platnoj kartici ni jednog trenutka nisu dostupni
            Sixtix doo, ni Instituciji. Prilikom unošenja podataka o platnoj
            kartici, poverljive informacije se prenose putem javne mreže u
            zaštićenoj (kriptovanoj) formi upotrebom SSL protokola i PKI
            Sistema, kao trenutno najsavremenije kriptografske tehnologije. U
            slučaju povraćaja novca potrošaču (reklamacija, odustanak od
            kupovine, itd.), povraćaj sredstava će biti izvršen na karticu,
            odnosno na tekući račun potrošača uz njegovu saglasnost. Prilikom
            povraćaja novca Potrošač će učiniti dostupnim podatak o tekućem
            računu na koji se imaju vratiti sredstva, što predstavlja podatak o
            ličnosti, koji je zaštićen u skladu sa Politikom privatnosti. U
            slučaju povraćaja sredstava kupcu koji je prethodno platio nekom od
            platnih kartica, delimično ili u celosti, a bez obzira na razlog
            vraćanja, Sixtix je u obavezi da povraćaj vrši isključivo preko
            VISA, EC/MC, Maestro i Dinacard metoda plaćanja, što znači da će
            Banka na zahtev obaviti povraćaj sredstava na račun korisnika platne
            kartice. S tim da se za svaku registrovanu karticu (bila jedna ili
            više) obavlja provera validnosti kartice i potrošača. Unos i prenos
            ličnih podataka i podataka o broju kartice zaštićeni su u skladu sa
            vodećim bezbednosnim protokolima na Internetu i u skladu sa PCI DSS
            standardima za sigurna plaćanja. S obzirom na to da svaka zemlja
            nezavisno određuje zakone koji regulišu promet roba i usluga, mogu
            se javiti situacije u kojima NEZAVISNO OD NAS određene državne
            službe uvedu dodatne poreze, takse ili dažbine na izvršene
            transakcije. Sixtix ne snosi odgovornost za takva obračunavanja, a
            Kupci se obavezuju da samostalno reše sva pitanja vezana za njihovu
            uplatu.
          </p>
          <p>
            Sva plaćanja biće izvršena u lokalnoj valuti Republike Srbije –
            dinar (RSD). Za informativni prikaz cena u drugim valutama koristi
            se srednji kurs Narodne Banke Srbije. Iznos za koji će biti zadužena
            Vaša platna kartica biće izražen u Vašoj lokalnoj valuti kroz
            konverziju u istu po kursu koji koriste kartičarske kompanije, a
            koji nama u trenutku kupovine ulaznice ne može biti poznat. Kao
            rezultat ove konverzije postoji mogućnost neznatne razlike u odnosu
            na originalne cene navedene na našem sajtu. Hvala Vam na
            razumevanju.
          </p>
          <p>
            <strong>
              5.1. PRAVILA I INFORMACIJE U VEZI SA PLAĆANJEM KARTICOM
            </strong>
          </p>
          <p>
            U procesu prihvatanja platnih kartica i izvršavanju platnih
            transakcija na internet stranici, novčana sredstava na ime usluge
            prihvatanja bezgotovinskog načina plaćanja platnim karticama
            Korisnika na stranici se putem elektronskih kanala podržanih od
            strane Banke prenose (uplaćuju) na poseban račun Institucije
            elektronskog novca za zaštitu novčanih sredstava korisnika kod
            Banke, u cilju daljeg prenosa na račune primaoca plaćanja. Uplatom
            novčanih sredstava od strane Korisnika na ime izvršenja platne
            transakcije upotrebom platne kartice na internet stranici, Korisnik
            daje izričitu saglasnost da se uplata novčanih sredstava izvrši u
            korist posebnog računa Institucije za zaštitu novčanih sredstava
            korisnika otvorenog kod Banke, i saglasan je da Sixtix izda
            instrukcije za prenos na platne račune primaoca plaćanja.
            Institucija ne odgovara za poreske kao i druge zakonske obaveze koje
            eventualno proizilaze iz ovlašćenog ili neovlašćenog korišćenja
            internet stranice od strane Korisnika.
          </p>
          <p>
            <strong>5.1.1. Predugovorno informisanje</strong>
          </p>
          <p>
            Kod svakog plaćanja putem internet stranice Korisnik sa Institucijom
            zaključuje ugovor o jednokratnoj platnoj transakcji, radi prihvata i
            prenosa novčanih sredstava primaocima plaćanja. Predugovorne
            informacije o jednokratnoj platnoj transakciji na internet stranici
            sadrže informacije o Ugovoru o jednokratnim platnim transakcijama
            prilikom plaćanja na stranici, informacije o izvršenju jednokratnih
            platnih transakcija, informacije i podatke o naknadama i terminskom
            planu za izvršenje jednokratnih platnih transakcija, informacije o
            načinu i sredstvima komunikacije između Korisnika i Institucije.
          </p>
          <p>
            Informacije o Ugovoru o jednokratnoj platnoj transakciji - Ugovor o
            jednokratnoj platnoj transakciji je ugovor na daljinu za izvršenje
            jednokratne platne transakcije kojim se uređuje izvršenje jedne
            određene platne transakcije. Zaključuje se između Institucije i
            Korisnika na internet stranici, kao sredstvu komunikacije na daljinu
            aktiviranjem od strane korisnika određenih opcija u sadržaju
            prikazanom na internet stranici i davanjem saglasnosti za
            izvršavanje jednokratne platne transakcije uspešnim iniciranjem
            kartične transakcije. Ugovor o jednokratnoj platnoj transakciji čine
            Opšti uslovi za pružanje platnih usluga i izdavanje elektronskog
            novca (u daljem tekstu: Opšti uslovi poslovanja Institucije) i
            Terminski plan Institucije koji su dostupni na{' '}
            <a className="terms__link-rs" href="https://www.payspot.rs">
              https://www.payspot.rs
            </a>{' '}
            , ovi Uslovi korišćenja i autorizovan nalog potrošača za izvršenje
            jednokratne platne transakcije. Izdavanjem naloga za izvršenje
            jednokratne platne transakcije odnosno iniciranjem plaćanja platnom
            karticom, smatra se da se Korisnik upoznao i da prihvata ove Uslove
            internet stranice i predugovorne informacije i uslove izvršavanja
            jednokratnih platnih transakcija Institucije koji su dostupni
            Korisniku na internet stranici pre izvršenja transakcije plaćanja i
            sa kojima se Korisnik saglasio. Ugovor o jednokratnoj platnoj
            transakciji se smatra zaključenim činom davanja saglasnosti od
            strane Korisnika za izvršenje jednokratne platne transakcije na
            internet stranici.
          </p>
          <p>
            Ugovor o jednokratnoj platnoj transakciji zaključuje se na srpskom
            jeziku. Korisnik ima pravo da mu se tokom trajanja ugovornog odnosa,
            na njegov zahtev, dostavi kopija naloga o jednokratnoj platnoj
            transakciji na papiru.
          </p>
          <p>
            <strong>
              5.1.2 Autorizacija i izvršavanje jednokratne platne transakcije
            </strong>
          </p>
          <p>
            Jednokratna platna transakcija određuje se platnim nalogom.
            Institucija prima platne naloge neposredno od strane internet
            stranice, koja ih dostavlja u ime i za račun Korisnika koji inicira
            izvršenje jednokratne platne transakcije:
          </p>
          <p>
            Smatra se da je platna transakcija autorizovana kada je korisnik dao
            saglasnost za njeno izvršenje. Autorizacijom naloga korisnik daje
            saglasnost za izvršenje platne transakcije u skladu sa uslovima koji
            su mu prezentovani neposredno pre davanja saglasnosti, kao i Opštim
            uslovima poslovanja Institucije{' '}
            <a className="terms__link-rs" href="https://www.payspot.rs">
              www.payspot.rs
            </a>{' '}
            , čime je Ugovor o jednokratnoj platnoj transakciji između
            Institucije i Korisnika zaključen.
          </p>
          <p>
            Institucija će izvršiti platni nalog kojim se traži izvršenje platne
            transakcije pod uslovom da je:
          </p>
          <ul>
            <li>
              nalog ispravno popunjen – što podrazumeva potpun unos podataka na
              platnom nalogu unosom minimuma podataka neophodnih za odobravanje
              transakcije;
            </li>
            <li>
              Korisnik osigurao dovoljno novčanih sredstava za izvršenje naloga,
              odnosno ako je Institucija primila na Račun kod banke iznos
              novčanih sredstava za izvršenje jednokratne platne transakcije;
            </li>
            <li>Korisnik dao saglasnost za izvršenje platnog naloga;</li>
            <li>
              ne postoje zakonske prepreke za izvršenje (prema drugim
              propisima).
            </li>
          </ul>

          <br />

          <p className="terms__subtitle">
            <strong>6. VRAĆANJE I ZAMENA ULAZNICA</strong>
          </p>
          <p>
            Povrat sredstava prethodno kupljenih ulaznica predstavlja
            diskreciono pravo organizacije koja prodaje (mi nemamo diskreciono
            pravo u vezi sa povraćajem novca) i može se obaviti samo preko te
            organizacije. U slučaju prevelikog plaćanja ili drugih grešaka
            uzrokovanih samim SixTix servisom i kada se te greške potvrde,
            povraćaj sredstava može biti izvršen prema nahođenju SixTix. U tom
            slučaju, kontaktirajte SIXTIX podršku putem{' '}
            <a className="terms__link-rs" href="mailto:info@sixtix.com">
              info@sixtix.com
            </a>
            .
          </p>
          <p>Povraćaj naplaćenih sredstava</p>
          <p>
            U slučaju vraćanja robe i povraćaja sredstava kupcu koji je
            prethodno platio nekom od platnih kartica, delimično ili u celosti,
            a bez obzira na razlog vraćanja, [naziv IPM] je u obavezi da
            povraćaj vrši isključivo preko DinaCard, Maetro/MasterCard i VISA
            metoda plaćanja, što znači da će Institucija elektronskog novca na
            zahtev prodavca obaviti povraćaj sredstava na račun korisnika platne
            kartice“.
          </p>
          <p>
            SIXTIX DOO nije organizator ponuđenih događaja. Događaj organizuje,
            vodi i realizuje organizator, koji takođe izdaje ulaznice.
            Organizator je isključivo odgovoran za povraćaj novca kupcima u
            slučaju otkazivanja ili odlaganja događaja.
          </p>

          <br />

          <p>
            <strong>
              Pravo na vraćanje ulaznica kupac ulaznice ima samo u sledećim
              slučajevima:
            </strong>
          </p>
          <ul>
            <li>otkazivanje događaja;</li>
            <li>
              odlaganje događaja na rok duži od 120 dana od dana planiranog
              održavanja događaja;
            </li>
            <li>
              odlaganje događaja zbog nastupanja više sile koja traje duže od
              180 dana od dana planiranog održavanja događaja.
            </li>
          </ul>
          <p>
            Viša sila, tokom koje miruju obaveze Organizatora, nastupa kada
            Organizator događaja nije u stanju da ispuni svoju obavezu
            održavanja događaja zbog rata, pobune, terorističkih akata,
            štrajkova, nesreća, požara, blokade, poplave, odluke ili akcije
            epidemiološke vlasti, prirodne katastrofe, teškog poremećaja u
            snabdevanju energijom ili bilo čega drugog, iz razloga koji je van
            njegove moći i kontrole.
          </p>
          <p>
            Ako je događaj otkazan ili odložen zbog navedenih okolnosti, SIXTIX
            će o tome obavestiti kupce što je pre moguće putem veb-sajta
            www.sixtix.com. Ukoliko je događaj odložen za novi termin, povraćaj
            novca za kupljene ulaznice korisnicima kojima novi termin ne
            odgovara biće moguć do početka događaja u novom terminu, osim
            ukoliko organizator događaja ne odluči drugačije.
          </p>
          <p>
            U slučaju povraćaja novca za kupovinu obavljenu na Internet
            prodavnici, kupcu će biti vraćen iznos cene ulaznice za predmetni
            događaj. Kupcu neće biti izvršen povraćaj troškova obrade od cene
            ulaznice, budući da se usluga SIXTIX-a smatra u celosti pruženom u
            trenutku kupovine ulaznice, o čemu je kupac obavešten i na šta
            pristaje.
          </p>
          <p>
            SIXTIX nema zakonsku obavezu da izvrši povraćaj novca ili zamenu
            ulaznice nakon završene kupovine, na subjektivni zahtev Kupca.
          </p>
          <p>
            U slučaju kupovine na internet prodajnom portalu sixtix.com Kupac
            prihvatanjem Uslova korišćenja tokom procesa kupovine izričito
            izjavljuje da je u skladu sa Zakonom, član 26, stav 1, tačka 6
            obavešten da ne može da koristi pravo na odustanak od ugovora
            zaključenog na daljinu, a u smislu Zakona, član 36, stav 1, tačka
            13.
          </p>
          <p>
            SIXTIX DOO deluje isključivo kao distributer za prodaju ulaznica u
            ime organizatora, zbog čega ne snosi nikakvu odgovornost u vezi sa
            organizacijom i/ili održavanjem događaja, te nije odgovoran za
            povraćaj novca kupcima u slučajevima otkazivanja ili odlaganja
            događaja.
          </p>

          <br />

          <p className="terms__subtitle">
            <strong>7. DOSTAVA I ISPORUKA</strong>
          </p>
          <p>
            U SixTix-u omogućavamo vam brzu i sigurnu dostavu ulaznica putem
            digitalnih kanala. Trenutno nudimo sledeće opcije isporuke:
          </p>
          <ul>
            <li>
              <strong>E-TICKET (Print@home).</strong> Vaše PDF ulaznice biće
              poslate na email koji ste naveli prilikom kupovine. PDF ulaznicu
              je potrebno odštampati na A4 formatu i pažljivo čuvati do
              događaja. Ukoliko događaj to zahteva od vas, PDF odštampanu
              ulaznicu obavezno ponesite sa sobom na ulaz.
            </li>
            <li>
              <strong>M-TICKET (Mobilna ulaznica).</strong> Vaša mobilna
              ulaznica (PDF prilagođen za prikaz na telefonu) biće poslata na
              email koji ste naveli prilikom kupovine. Preporučujemo da sačuvate
              ulaznicu u svom telefonu i proverite bateriju pre dolaska na
              događaj.
            </li>
            <li>
              <strong>Digital Wallet (e-novčanik).</strong> Pored standardnih
              opcija, omogućili smo i direktno dodavanje ulaznice u digitalni
              wallet na vašem telefonu. Dostupnost ove opcije zavisi isključivo
              od klijenta koji organizuje događaj. Digitalna ulaznica u vašem
              telefonu znači lakši pristup događaju bez potrebe za štampanjem i
              dodatnu sigurnost pri verifikaciji.
            </li>
          </ul>
          <p>
            Bez obzira na način dostave, važno je da svoje ulaznice čuvate na
            sigurnom mestu i imate ih spremne prilikom dolaska na događaj.
          </p>

          <br />

          <p className="terms__subtitle">
            <strong>
              8. ZAKONSKA ODGOVORNOST TRGOVCA/ORGANIZATORA ZA SAOBRAZNOST
            </strong>
          </p>
          <p>
            U skladu sa Zakonom o zaštiti potrošača, trgovac koji je prodao
            uslugu potrošaču odgovara za saobraznost iste u zakonskom roku.
          </p>
          <p>
            Usluga nije saobrazna ako: po sadržini, kvalitetu i svrsi ne
            odgovara opisu koji je trgovac pre zaključenja ugovora dao oglasom
            ili na drugi sličan način; ne odgovara opisu koji je trgovac dao u
            toku pružanja usluge pod uslovom da je to moglo da utiče na odluke
            potrošača; nema posebna svojstva koja je zahtevao potrošač, a koja
            su trgovcu bila ili su morala biti poznata u trenutku zaključenja
            ugovora; nema redovna svojstva usluga iste vrste; ne odgovara
            očekivanjima koja su osnovana s obzirom na prirodu usluge i javna
            obećanja organizato u pogledu posebnih svojstava usluge, a naročito
            ako su učinjena oglasom; po sadržini, kvalitetu i svrsi ne odgovara
            opisu koji je pre zaključenja ugovora, oglasom ili na drugi sličan
            način dalo treće lice u ime trgovca. Trgovac nije odgovoran za
            nesaobraznost usluge ako: nije znao ili nije morao da zna da je
            treće lice u njegovo ime dalo opis u njegovo ime; je sporni opis na
            odgovarajući način blagovremeno ispravljen.
          </p>
          <p>
            Usluga je saobrazna ugovoru ako: po sadržini, kvalitetu i svrsi
            odgovara opisu koji je trgovac pre zaključenja ugovora dao oglasom
            ili na drugi sličan način; odgovara opisu koji je trgovac dao u toku
            pružanja usluge pod uslovom da je to moglo da utiče na odluke
            potrošača; ima posebna svojstva koja je zahtevao potrošač, a koja su
            trgovcu bila ili su morala biti poznata u trenutku zaključenja
            ugovora; ima redovna svojstva usluga iste vrste; odgovara
            očekivanjima koja su osnovana s obzirom na prirodu usluge i javna
            obećanja trgovca u pogledu posebnih svojstava usluge, a naročito ako
            su učinjena oglasom; po sadržini, kvalitetu i svrsi odgovara opisu
            koji je pre zaključenja ugovora, oglasom ili na drugi sličan način
            dalo treće lice u ime trgovca.
          </p>
          <p>
            Ako usluga nije saobrazna ugovorenoj, potrošač može da zahteva od
            trgovca da izvrši saobraznu uslugu. Ako je izvršenje saobrazne
            usluge nemoguće ili protivpravno, potrošač može zahtevati raskid
            ugovora. Ako izvršenje saobrazne usluge predstavlja nesrazmerno
            opterećenje za trgovca, potrošač može zahtevati umanjenje cene ili
            raskid ugovora. Ako usluga nije saobrazna ugovorenoj, na prava
            potrošača i odgovornost trgovca shodno se primenjuju odredbe čl.
            49-55. Zakona o zaštiti potrošača.
          </p>
          <p>
            Trgovac je u obavezi da o isporučenoj robi/uslugama obezbedi jasan i
            pouzdan dokaz da je roba/usluga preuzeta od strane potrošača,
            odnosno ovlašćene osobe. U slučaju prodaje materijalnih dobara dokaz
            mora biti u formi dostavnice koja ima iste obavezujuće elemente kao
            i potvrda o plaćanju i to: podaci o potrošaču o ime i prezime
            potrošača odnosno ovlašćenog lica koje je preuzelo robu/ulsuge o
            adresa o broj i vid identifikacionog dokumenta potrošača odnosno
            ovlašćenog lica koje je preuzelo robu/ulsuge o potpis potrošača
            odnosno ovlašćenog lica koje je preuzelo robu/ulsuge, podaci o
            narudžbini, podaci o Trgovcu, podaci o transakciji, datum isporuke.
            U slučaju da se radi o nematerijalnim dobrima ili uslugama koje se
            isporučuju elektronskim putem dokaz može biti u formi elektronskih
            poruka i logova sa servera. Trgovac je u obavezi da u periodu od 2
            (dve) godine od momenta nastanka transakcije, na bezbedan i siguran
            način arhivira sve dokaze opisane u prethodnom stavu, kao i da ih
            dostavi na zahtev Banke u slučaju reklamacije transakcije.
          </p>

          <br />

          <p className="terms__subtitle">
            <strong>
              9. REŠAVANJE SPOROVA – NADLEŽNOST SUDA I MERODAVNO PRAVO
            </strong>
          </p>
          <p>
            Ugovorne strane su saglasne da sve eventualne nesporazume i sporna
            pitanja koja nastanu tokom trajanja ugovornog odnosa nastojati da
            reše mirnim putem. U slučaju da izostane mirno rešenje nesporazuma i
            spornih pitanja ugovara se nadležnost stvarno nadležnog suda u
            Beogradu, a primenjuje se pravo Republike Srbije.
          </p>
          <p>
            <strong>9.1. VANSUDSKO REŠAVANJE POTROŠAČKIH SPOROVA</strong>
          </p>
          <p>
            U skladu sa Zakonom o zaštiti potrošača, potrošač može spor da reši
            u postupku vansudskog rešavanja spora, na način definisan Zakonom.
          </p>

          <br />

          <p className="terms__subtitle">
            <strong>10. REKLAMACIJE</strong>
          </p>
          <p>
            Potrošač može da izjavi reklamaciju radi ostvarivanja svojih prava
            iz člana 51. i člana 80. Zakona o zaštiti potrošača (&quot;Sl.
            glasnik RS&quot;, br. 88/2021), kao i zbog pogrešno obračunate cene
            i drugih nedostataka, usmeno na prodajnom mestu gde je ulaznica
            kupljena ili na sledeći način:
          </p>

          <ul>
            <li>
              elektronskim putem – na mejl adresu{' '}
              <a className="terms__link-rs" href="mailto:info@sixtix.com">
                info@sixtix.com
              </a>
              ,
            </li>
            <li>poštom – na adresu sedišta Humska 1, Savski Venac, Beograd</li>
          </ul>

          <p>
            Prilikom izjave reklamacije, potrošač je dužan da dostavi račun kao
            dokaz o kupovini (kopija računa, slip i sl.).
          </p>

          <br />

          <p className="terms__subtitle">
            <strong>11. ZAVRŠNE ODREDBE </strong>
          </p>
          <p>
            Ovi opšti uslovi doneti su dana 14.02.2025. godine, javno objavljeni
            dana 16.02.2025. godine od kog dana se i primenjuju u potpunosti.
            Izmena ovih Uslova vršiće se u skladu sa izmenama pravila postupanja
            i funkcionisanja internet stranice kao i u drugim slučajevima koje
            trgovac po svojoj apsolutnoj diskreciji utvrdi. Ukoliko bilo koji
            uslov ili odredba sadržana u ovim Uslovima korišćenja postane
            nepunovažna, to neće uticati na punovažnost ostalih uslova i odredbi
            koje nisu pogođene takvom nepunovažnošću. Potrošači su dužni da
            prate ove Uslove korišćenja i izmene istih, imajući u vidu da su
            javno dostupni, kao i da je u interesu potrošača da bude upoznat sa
            istima.
          </p>
        </div>
      </div>
    </section>
  );
};
